import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { LocationGroupRepository } from '../../repositories/location-group.repository';

@Injectable({ providedIn: 'root' })
export class DeleteLocationGroupUsecase implements UseCase<string, boolean> {
  constructor(private readonly locationGroupRepository: LocationGroupRepository) {}

  execute(params: string): Observable<boolean> {
    return this.locationGroupRepository.DeleteLocationGroup(params);
  }
}
